import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Pill from 'flarum/common/components/Pill';
import Tooltip from 'flarum/common/components/Tooltip';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
export default class PollDraftBadges extends Component {
  view() {
    if (!this.attrs.poll.isDraft()) return null;
    return m("span", {
      className: "PollDraftBadges"
    }, this.items().toArray());
  }
  items() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    items.add('draft', m(Pill, {
      className: "PollDraftBadges-draft"
    }, m(Icon, {
      name: "fas fa-pencil-alt"
    }), app.translator.trans('fof-polls.forum.poll.draft_label')), 100);
    if (poll.isScheduled()) {
      items.add('scheduled', m(Pill, {
        className: "PollDraftBadges-scheduled"
      }, m(Icon, {
        name: "fas fa-clock"
      }), app.translator.trans('fof-polls.forum.poll.scheduled_label', {
        date: dayjs(poll.scheduledPublishAt()).format('lll')
      }), this.scheduleError()), 50);
    }
    return items;
  }

  // Tooltip replaces the aria-label of what it wraps.
  scheduleError() {
    if (!this.attrs.poll.scheduledPublishError()) return null;
    return m(Tooltip, {
      text: extractText(app.translator.trans('fof-polls.forum.poll.scheduled_error_tooltip'))
    }, m("span", {
      className: "PollDraftBadges-scheduleError"
    }, m(Icon, {
      name: "fas fa-exclamation-triangle"
    })));
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollDraftBadges', PollDraftBadges);